/**
 * Store API write helpers — actor id for created_by / updated_by.
 * tenant_id and hospital_id are resolved server-side from ORG-CODE (Axios-interceptor).
 */

function sessionUserId() {
  const v = sessionStorage.getItem('USER_ACCESS_KEY');
  return v && v !== 'null' && v !== 'undefined' ? v : null;
}

/** Attach created_by on POST bodies when not already set. */
export function withStoreCreateBody(body = {}) {
  const payload = { ...body };
  const actor = sessionUserId();
  if (actor && !payload.created_by) payload.created_by = actor;
  return payload;
}

/** Attach updated_by on PATCH/PUT/POST update bodies when not already set. */
export function withStoreUpdateBody(body = {}) {
  const payload = { ...body };
  const actor = sessionUserId();
  if (actor && !payload.updated_by) payload.updated_by = actor;
  return payload;
}

export function getStoreActorId() {
  return sessionUserId() || '';
}

/** Display name of the signed-in user, for services that snapshot it (gate pass). */
export function getStoreActorName() {
  return sessionStorage.getItem('userName') || '';
}

/**
 * Display label for a created_by / authorized_by actor id.
 *
 * The inventory service stores actors as opaque ids and resolves no names, so the
 * only id we can name is the signed-in user's own. Everyone else is shown as a
 * shortened id rather than a guessed name.
 */
export function resolveActorLabel(actorId) {
  if (!actorId) return '—';
  const id = String(actorId);
  if (id === sessionUserId()) {
    return sessionStorage.getItem('userName') || 'You';
  }
  return id.length > 12 ? `${id.slice(0, 8)}…` : id;
}
